export const apiWrapper = async ({ fetch, url, options = {} }) => {
  return await new Promise((resolve, reject) => {
    const apiFn = async () => {
      try {
        const response = await fetch(url, options)
        const jsonData = await response.json()
        if (jsonData.error) {
          reject(jsonData.error)
        } else {
          resolve(jsonData)
        }
      } catch(e) {
        reject(e)
      }
    }
    apiFn();
  })
}

const extractFileName = (response) => {
  const headers = response.headers;
  const contentDisposition = headers.get('Content-Disposition');
  const match = contentDisposition && contentDisposition.match(/filename=(.+)/);
  return match ? match[1] : 'data.csv'; // Default filename if not found
}

export const apiDownloadWrapper = async ({ fetch, url, options = {} }) => {
  return await new Promise((resolve, reject) => {
    const apiFn = async () => {
      try {
        const response = await fetch(url, options)

        const blob = await response.blob(); 

        const fileName = extractFileName(response)

        const linkUrl = window.URL.createObjectURL(blob);

        // Create an anchor element
        const link = document.createElement('a');
        link.href = linkUrl;
        link.setAttribute('download', fileName); // Set filename for download
        document.body.appendChild(link);

        // Simulate click on the anchor element to trigger download
        link.click();

        // Cleanup: remove the anchor and revoke the URL
        document.body.removeChild(link);
        window.URL.revokeObjectURL(linkUrl);

      } catch(e) {
        reject(e)
      }
    }
    apiFn();
  })
}

export const objectToQueryString = (obj) => {
  const params = new URLSearchParams();
  Object.entries(obj).forEach(([key, value]) => {
    // Do this so zeros are potentially valid as a parameter
    if (value !== undefined && value !== null && value !== '') {
      params.append(key, value);
    }
  });
  const queryString = params.toString();
  return queryString ? `?${queryString}` : '';
};